module.exports = {"data":{"site":{"siteMetadata":{"facebook":{"appId":"3408220195885721"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 633
// module chunks = 142629428675168